<template>
	<div class="col">
		<div class="card mb-3" :class="typeClass">
			<div class="card-header d-flex justify-content-between align-items-center">
				{{ note.note_type.name }} - {{ note.created_at }}
				<div>
	                <button class="btn btn-sm btn-outline-secondary" @click="openForm">Edit</button>
	                <button class="btn btn-sm btn-outline-danger ms-2" @click="deleteNote">Delete</button>
	            </div>
			</div>
	        <div class="card-body">
	            <div class="card-text">
	                <p>{{ note.content }}</p>
					<p><em>Created by {{ note.user?.full_name }} at {{ note.created_at }}</em></p>
	            </div>
	        </div>
	    </div>
	</div>
</template>

<script>
export default {
	name: "NoteCard",
	props: {
		note: Object
	},
	data() {
		return {
			//
		}
	},
	methods: {
		deleteNote() {
			this.$store.dispatch('notes/deleteNote', this.note)
		},
		openForm() {
            this.$store.dispatch('notes/setFormOpen', true)
            this.$store.dispatch('notes/setNoteInForm', this.note)
        },
	},
	computed: {
		typeClass: function() {
			return (this.note.note_type_id == 2) ? 'border-danger text-danger' : ''
		}
	}
}

</script>